/**
 * Created by intellicar-rinas on 17/1/18.
 */
import React, { Component } from "react";
import "./InPieChart.css";
import $ from "jquery";
import * as d3 from "d3";

class InPieChart extends Component {
  state = {
    unit: "NO DATA",
    data: [],
  };

  data = [];

  constructor() {
    super();
    ["init", "draw"].map((i) => {
      this[i] = this[i].bind(this);
    });
  }

  componentDidMount() {
    this.mounted = true;
    this.init();
    this.resume();
  }

  saveState(prevProps) {
    if (!prevProps.saveState) return;
    prevProps.saveState(this.dataRaw, prevProps.schemaKey, this.props.data);
  }

  componentDidUpdate(prevProps) {
    this.saveState(prevProps);
  }

  componentWillUnmount() {
    this.mounted = false;
    this.saveState(this.props);
  }

  resume() {
    if (!this.mounted) return;
    if (this.props.resume && this.props.resume.state) {
      this.setData(this.props.resume.state);
    }
  }

  setData(data) {
    if (!data.unit || !data.data) return;

    this.dataRaw = data;
    this.data = data.data;
    this.setState(
      { unit: data.unit, name: data.name, data: data.data },
      this.draw
    );
  }

  setBusy = (busy) => {
    this.setState({ busy });
  };

  draw() {
    if (this.refs.svg) {
      $(this.refs.svg).empty();

      let data = this.data;

      let width = this.width,
        height = this.height,
        radius = this.radius;

      let arc = d3
        .arc()
        .outerRadius(radius - 6)
        .innerRadius(0);

      let labelArc = d3
        .arc()
        .outerRadius(radius - 26)
        .innerRadius(radius - 26);

      let pie = d3
        .pie()
        .sort(null)
        .value(function (d) {
          return d;
        });

      let svg = d3
        .select(this.refs.svg)
        .attr("width", width)
        .attr("height", height)
        .append("g")
        .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

      const mouseEvent = (tag, path) => {
        switch (tag) {
          case "mouseenter":
            // path.style("fill", d=> { return this.data[d.index].overlayColor || '#ff0'; });
            path.style("transform", "scale(1.02)");
            break;

          case "mouseleave":
            // path.style("fill", d=> { return this.data[d.index].color; });
            path.style("transform", "scale(1)");
            break;
        }
      };

      let g = svg
        .selectAll(".arc")
        .data(
          pie(
            data.map((d) => {
              return d.value;
            })
          )
        )
        .enter()
        .append("g")
        .attr("class", "arc")
        .on("mouseenter", function () {
          mouseEvent("mouseenter", d3.select(this).select("path"));
        })
        .on("mouseleave", function () {
          mouseEvent("mouseleave", d3.select(this).select("path"));
        });

      g.append("path")
        .attr("d", arc)
        .style("fill", (d) => {
          return this.data[d.index].color;
        });

      g.append("text")
        .attr("transform", function (d) {
          return "translate(" + labelArc.centroid(d) + ")";
        })
        .attr("dy", ".35em")
        .text((d) => {
          if (this.props.data && this.props.data.percent) {
            let val = this.data[d.index].value || 0;
            if (val == 0) return "";
            let total = this.data
              .map((d) => d.value)
              .reduce((c, v) => c + (v || 0), 0);
            let percent = (val / total) * 100;
            percent = percent % 1 != 0 ? percent.toFixed(1) : percent;
            return percent + "%";
          }
          return this.data[d.index].value ? this.data[d.index].value : "";
        });
    } else {
      setTimeout(this.draw, 100);
    }
  }

  init() {
    if (this.refs.container) {
      let ActWidth = $(this.refs.container).width();
      let ActHeight = $(this.refs.container).height();
      let marginLeft = 0;
      let marginTop = 0;
      let width = 0;
      let height = 0;

      if (ActWidth < ActHeight) {
        width = height = ActWidth;
        marginTop = (ActHeight - ActWidth) / 2;
      } else {
        width = height = ActHeight;
        marginLeft = (ActWidth - ActHeight) / 2;
      }

      $(this.refs.chartContainer).css({ width, height, marginLeft, marginTop });
      this.setState({ height, width }, this.draw);

      this.width = width;
      this.height = height;
      this.radius = height / 2;
    } else {
      setTimeout(this.init, 1000);
    }
  }

  render() {
    return (
      <div
        className={
          "InPieChart " + (this.props.data ? this.props.data.graphSetName : "")
        }
      >
        {this.state.busy ? (
          <div className="ipc-busy">
            <div className="ipcb-spinner"></div>
          </div>
        ) : (
          ""
        )}
        <div className="ipc-chart" ref="container">
          <div className="ipc-chartContainer" ref="chartContainer">
            {this.props.data && !this.props.data.hideinfo && (
              <div>
                <div className="ipcc-outline"></div>
                <div className="ipcc-outline2"></div>
                <div className="ipcc-unit">{this.state.unit}</div>
              </div>
            )}
            {this.state.width && this.state.height ? (
              <svg
                ref="svg"
                width={this.state.width}
                height={this.state.height}
              ></svg>
            ) : null}
          </div>
        </div>
        <div className="ipc-name">{this.state.name}</div>
        <div className="ipc-legends">
          {this.state.data.map((item, index) => {
            return (
              <div className="ipcl-item" key={index}>
                <div
                  className="ipcli-color"
                  style={{ background: item.color }}
                ></div>
                <div className="ipcli-name">{item.name}</div>
                <div className="ipcli-value">{item.value}</div>
                <div className="ipcli-unit"> {item.unit}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default InPieChart;
